/**
 * Proxy fetch for Live Link POST encrypt URLs (avoids third-party CORS).
 */

import { fetchLiveLinkUrl as fetchLiveLinkUrlSdk } from "@/hera-api/client";

export async function fetchLiveLinkUrl(
  url: string,
): Promise<Record<string, unknown>> {
  const result = await fetchLiveLinkUrlSdk({
    body: { url },
  });

  if (result.error) {
    const err = result.error as { detail?: string; message?: string };
    throw new Error(
      err.detail ?? err.message ?? "Failed to resolve Live Link URL",
    );
  }

  const payload = result.data;
  if (!payload?.data || typeof payload.data !== "object") {
    throw new Error("Live Link fetch returned an unexpected response.");
  }
  return payload.data as Record<string, unknown>;
}
